<div class="flex justify-center w-full md:mt-11 pb-8">
    <img src="assets/icons/Icons/other-payment-options/lifestyle_rewards_logo.svg" alt="lifestyle rewards logo">
</div>
<div class="w-full">
    <p class="my-6">Pay using your Lifestyle Rewards points&#33;</p>
    <p class="my-4">Redeem your accumulated Lifestyle Rewards points to pay for your purchase.</p>
    <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
        <b class="col-span-1">Step 1:</b>
        <p class="col-span-3 md:col-span-5">Enter your mobile number and PIN</p>
    </div>
    <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
        <b class="col-span-1">Step 2:</b>
        <p class="col-span-3 md:col-span-5">Confirm the amount to spend</p>
    </div>
    <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
        <b class="col-span-1">Step 3:</b>
        <p class="col-span-3 md:col-span-5">Transaction processed successfully</p>
    </div>
</div>
